<template>
  <edn-field
    autocomplete="false"
    type="text"
    ref="input"
    v-model="getInputDate"
    v-bind="$attrs"
    :rules="rules"
    :invalidMsg="invalidMsg"
    v-on="$listeners"
    :iconSmall="iconSmall"
    :isIrisBlack="isIrisBlack"
    :error-messages="errorMessages || propErrorMessages"
    @blur="checkErrorStatus()"
  >
    <template v-slot:content><slot name="content"></slot></template>
  </edn-field>
</template>

<script>
import { ednRequired } from './mixins/ednRequired'

export default {
  components: {
  },
  mixins: [ednRequired],
  props: {
    pattern: {
      type: RegExp,
      default: () => /[^.\d ]/gu,
    },
     invalidMsg: {
      type: String,
      default: () => '',
    },
    value: null,
    iconSmall: {
      type: Boolean,
      default: () => false,
    },
    isIrisBlack: {
      type: Boolean,
      default: () => false,
    },
    propErrorMessages:{
      type: String,
      default: () => '',
    }
  },
  data() {
    return {
      preValue: null,
      filteredValue: null,
      inputValue: null,
      errorMessages: '',
      errorStatus: false
    }
  },
  inheritAttrs: false,
  created () {
    this.inputValue = this.value;
    if (!this.value) {
      this.errorMessages = this.getErrorMessages(this.fldRequiredVal);
    }
  },
  computed: {
    getInputDate: {
      get() {
        return this.value;
      },
      set(newValue) {
        // validate new value
        this.inputValue = newValue;
        this.textFilter();
      }
    }
  },
  methods: {
    /* eslint-disable no-unused-vars */
    textFilter() {
      // debugger
      // if the value is null, the parent value is not set
      if (this.inputValue != null) {
        if (this.inputValue && (this.inputValue[0] === '-' || this.inputValue[0] === '+')) {
          this.inputValue = this.inputValue[0] + this.inputValue.slice(1).replaceAll(this.pattern, '')
        } else if(!this.isIrisBlack){
          this.inputValue = this.inputValue.replaceAll(this.pattern, '');
        }
      }
      this.checkFieldValue();
      this.$emit('input',  this.inputValue)
    },
    checkFieldValue() {
      // update lazyValue
      if (this.$refs && this.$refs.input && this.$refs.input.$refs['edn-field-input']) {
        if (this.isIrisBlack && this.fldRequiredVal) {
          // if it is empty, but the inputValue is not empty, it means the user remove the value, display error message
          if (this.$refs.input.$refs['edn-field-input'].lazyValue == '' ||  this.inputValue == '') {
            this.errorMessages = this.getErrorMessages(this.fldRequiredVal);
          } else if (this.inputValue) {
            // if not, clean the errpr message
            this.errorMessages = '';
          }
        }
        this.$refs.input.$refs['edn-field-input'].lazyValue = this.inputValue;
      }
    },
    checkErrorStatus () {
      this.textFilter();
      if (this.isIrisBlack && this.fldRequiredVal) {
        if (this.$refs && this.$refs.input && this.$refs.input.$refs['edn-field-input'].lazyValue == '') {
          this.$refs.input.$refs['edn-field-input'].lazyValue = this.value;
          this.inputValue = this.value;
        } else {
          this.errorMessages = '';
        }
      }

    },
    getErrorMessages(value) {
      if(this.propErrorMessages){
        return this.propErrorMessages;
      }else if (typeof this.fldRequiredVal === "boolean" && !this.fldRequiredVal) {
        return ''
      } else if (typeof this.fldRequiredVal === "boolean" && this.fldRequiredVal) {
        return this.requiredMsg;
      } 
      return this.fldRequiredVal;
    }
  },
  watch: {
    "value": function (val) {
      this.inputValue = val;
      if (this.isIrisBlack && this.fldRequiredVal) {
        if (!val) {
          this.errorMessages = this.getErrorMessages(this.fldRequiredVal);
        } else {
          this.errorMessages = '';
        }
      }
    }
  },
}
</script>
